import axios from "axios";
import { getAxiosConfigWithToken } from "../helpers/functions_helper"
import * as url from "../helpers/url_helper"

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

class BankHolidayService {
    
    async create(data: any) {
        const response = await axios
            .post(
                SERVER_URL + url.BANK_HOLIDAY.CREATE,
                data,
                {
                    headers: getAxiosConfigWithToken()
                }
            );

        return response.data;
    }

    async update(data: any) {
        const response = await axios
            .put(
                SERVER_URL + url.BANK_HOLIDAY.UPDATE,
                data,
                {
                    headers: getAxiosConfigWithToken()
                }
            );

        return response.data;
    }

    async getAll(data: any) {
        const response = await axios
            .post(SERVER_URL + url.BANK_HOLIDAY.GET_ALL, data,
                {
                    headers: getAxiosConfigWithToken(),
                }
            ).then(function (response: any) {
                return response;
            })
            .catch(function (error: any) {
                return error;
            });
        return response;
    }

    async delete(id: any) {
        const response = await axios
            .delete(
                SERVER_URL + url.BANK_HOLIDAY.DELETE +'/'+ id,
                {
                    headers: getAxiosConfigWithToken(),
                }
            );

        return response.data;
    }

    async getCalenderList() {
        const response = await axios
            .get(
                SERVER_URL + url.BANK_HOLIDAY.LIST,
                {
                    headers: getAxiosConfigWithToken(),
                }
            );

        return response.data;
    }

    async bulkcreate(data: any) {
        const response = await axios
            .post(
                SERVER_URL + url.BANK_HOLIDAY.BULK_CREATE,
                data,
                {
                    headers: getAxiosConfigWithToken()
                }
            );

        return response.data;
    }

}

export default new BankHolidayService();